// Return a stringified JSON object
export default function (value) {
  return JSON.stringify(value);
}
